import { DispatchDeliveryOrderResponseDto } from "@/api/portal"

export const loadTypeMapping = {
  [DispatchDeliveryOrderResponseDto.loadType.LIVE_LOAD]: "LIVE",
  [DispatchDeliveryOrderResponseDto.loadType.DROP_AND_PICK]: "D&P",
}
